import React from "react";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";

function QuickSearchToolbar() {
    return (
        <Box
            sx={{
                p: 0.5,
                pb: 0,
            }}
        >
            <GridToolbarQuickFilter />
        </Box>
    );
}

export default function Basic(props) {
    const { t } = useTranslation();
    let userAttributes = [];
    let i = 0;

    if (props.subscriberList !== undefined) {
        for (const key of Object.keys(props.subscriberList)) {
            userAttributes.push({
                id: i.toString(),
                subscriber: props.subscriberList[key],
            });
            i = i + 1;
        }
    }

    const columns = [
        {
            headerName: "Subscriber ID",
            field: "subscriber",
            flex: 1,
            minWidth: 200,
        },
    ];

    const rows = userAttributes;

    return (
        <div style={{ height: 300, width: "100%" }}>
            <DataGrid
                rows={rows}
                columns={columns}
                hideFooterPagination={false}
                hideFooter={true}
                getRowHeight={({ id, densityFactor }) => {
                    return 50 * densityFactor;
                }}
                slots={{ toolbar: QuickSearchToolbar }}
                localeText={{
                    noRowsLabel: t("recentservice.nomatches"),
                }}
            />
        </div>
    );
}
